var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 194,
    viewBox: "0 0 216 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 22.8423,
    width: 167,
    height: 171,
    rx: 10,
    fill: "#7A98FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.6716,
    y: 1.34229,
    width: 129,
    height: 108,
    rx: 14.5,
    stroke: "#6083FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign01);
export default __webpack_public_path__ + "static/media/design01.f1ae838d05f6575b383fe6593e6d7d65.svg";
export { ForwardRef as ReactComponent };